import * as TanStackQueryProvider from "../integrations/tanstack-query/root-provider.tsx";
import { ThemeProvider } from "@/components/theme/ThemeProvider.tsx";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "@/auth/msal.ts";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { routeTree } from "@/routeTree.gen.ts";
import { MsalSync } from "@/components/auth/MsalSync.tsx";
import { TooltipProvider } from "@/components/ui/tooltip.tsx";
import { AuthGate } from "@/auth/AuthGate.tsx";

const TanStackQueryProviderContext = TanStackQueryProvider.getContext();

// Create a new router instance
const router = createRouter({
  routeTree,
  context: {
    ...TanStackQueryProviderContext,
  },
  defaultPreload: "intent",
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export function Providers() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
      <MsalProvider instance={msalInstance}>
        <TanStackQueryProvider.Provider {...TanStackQueryProviderContext}>
          <MsalSync />
          <TooltipProvider delayDuration={300}>
            <AuthGate>
              <RouterProvider router={router} />
            </AuthGate>
          </TooltipProvider>
        </TanStackQueryProvider.Provider>
      </MsalProvider>
    </ThemeProvider>
  );
}
